import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-scroll',
  templateUrl: './scroll.component.html',
  styles: []
})
export class ScrollComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
